export default __webpack_public_path__ + "static/2-9e2a50f0b10f643e9d35e4370e7c5334.jpg";